import React, { useState } from "react";
import { GramPostProps } from "./TheGramAppInterfaces";
import Dots from "./MMC_Phone App_TheGram_Dots.svg";

type GramPostPropss = {
  post: GramPostProps;
};

const GramPost: React.FC<GramPostPropss> = ({ post }) => {
  const [showComments, setShowComments] = useState(false);

  const handleToggleComments = () => {
    setShowComments(!showComments);
  };
  return (
    <div className="gram-post">
      <div className="profile">
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={post.Profile.image}
            alt="Profile"
            className="profile-image"
          />
          <div className="profile-details">
            <div className="profile-name">{post.Profile.name}</div>
            <div className="location">{post.Location}</div>
          </div>
        </div>
        <img src={Dots} alt="Post" className="dots" />
      </div>
      <div className="dots-contatiner">
        {" "}
        <img src={post.Image} alt="Post" className="post-image" />
      </div>
      <div className="post-details">
        <div className="likes">{post.Likes} Likes</div>
        <div className="caption-group">
          <div className="caption-profile">{post.Profile.name}</div>
          <div className="caption">{post.Caption}</div>
        </div>
        <div className="date">{post.Date}</div>
      </div>
      {post.Comments && post.Comments.length > 0 && (
        <div className="comments-section">
          <button onClick={handleToggleComments}>
            {showComments ? "Hide Comments" : "Show Comments"}
          </button>
          {showComments && (
            <div className="comments">
              {post.Comments.map((comment, index) => (
                <div key={index} className="comment">
                  <img
                    src={comment.ProfilePic}
                    alt="Commenter"
                    className="comment-profile-pic"
                  />
                  <div className="comment-details">
                    <div className="commenter-name">{comment.Commenter}</div>
                    <div className="comment-text">{comment.Comment}</div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default GramPost;
